import { Currency } from '@/core/currency/interfaces';

const SBD: Currency = {
    name: 'Solomon Islands Dollar',
    demonym: 'Solomon Islands',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '090',
    symbol: 'SI$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SBD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SBD;
